// Lot 6 : charge ressentis et repas de l'app depuis le dernier rendez-vous
// relu. Ne bloque jamais : en cas d'échec, l'écran le dit et la préparation
// reste possible.

import { useEffect, useState } from 'react';
import { chargerRessenti, dernierRendezVous } from './suiviRessenti';

export default function useRessenti(client, { charger = chargerRessenti } = {}) {
  const rdv = dernierRendezVous(client);
  const depuis = rdv?.date ? String(rdv.date).slice(0, 10) : null;
  const cle = client?.id ? `${client.id}|${depuis || ''}` : null;
  const [lu, setLu] = useState({ cle: null, donnees: null });

  useEffect(() => {
    if (!cle) return undefined;
    let vivant = true;
    Promise.resolve()
      .then(() => charger(client, depuis))
      .catch(() => ({ ok: false, message: 'Les données de l’app n’ont pas pu être chargées. Tu peux préparer la version quand même.' }))
      .then((donnees) => { if (vivant) setLu({ cle, donnees }); });
    return () => { vivant = false; };
    // Rechargé quand la cliente ou le rendez-vous de référence change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cle]);

  return {
    rdv,
    depuis,
    donnees: lu.cle === cle ? lu.donnees : null,
  };
}
